import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { CollectionsService } from '../../../../services/collections.service';

@Component({
  selector: 'app-print-collections',
  templateUrl: './print-collections.component.html',
  styleUrls: ['./print-collections.component.scss'],
})
export class PrintCollectionsComponent implements OnInit {
  public collectionServicesList: any = [];
  public date: any;
  public type: string;
  public columns: any = [
    {
      header: this.translate.instant('general.jobcard_no'),
      field: 'jobCardNo',
      type: 'jobcardno',
    },
    {
      header: this.translate.instant('bikeshop.collections.address'),
      field: 'fullAddress',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.name'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.contact_details'),
      field: 'phoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.bike_model'),
      field: 'bikeModel',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.customer_notes'),
      field: 'notes',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.collections.date'),
      field: 'scheduleDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.collections.time'),
      field: 'timeSlot',
      type: 'time',
    },
    {
      header: this.translate.instant('bikeshop.collections.collected'),
      field: 'Collected',
      type: 'action',
    },
  ];

  public tab = '';
  public startDate = '';
  public endDate = '';
  public partners = '';

  constructor(
    private translate: TranslateService,
    private collectionService: CollectionsService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((res: any) => {
      this.tab = res.Type;
      this.startDate = res.StartDate;
      this.endDate = res.EndDate;
      this.partners = res.Partners;
    });

    this.getData();
  }

  getData() {
    if (this.tab === 'Collections') {
      this.collectionService
        .getCollections(this.startDate, this.endDate, this.partners)
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 10 ? 1 : 0 };
              },
            );
            console.log();

            setTimeout(() => {
              window.print();
            }, 500);
          },
          (err) => {
            this.collectionServicesList = [];
          },
        );
    } else {
      this.collectionService
        .getDropOffs(this.startDate, this.endDate, this.partners)
        .subscribe(
          (res) => {
            this.collectionServicesList = res;
            this.collectionServicesList = this.collectionServicesList.map(
              (x) => {
                return { ...x, collected: x.statusID === 20 ? 1 : 0 };
              },
            );

            setTimeout(() => {
              window.print();
            }, 500);
          },
          (err) => {
            this.collectionServicesList = [];
          },
        );
    }
  }
}
